import { FC, memo } from 'react'
import { Alert, Box, Icon, SpaceBetween } from '@cloudscape-design/components'
import type { MongoDBComment } from '../../../types/mongodb'

interface CommentsOverviewProps {
	comments: MongoDBComment[]
}

const CommentsOverview: FC<CommentsOverviewProps> = ({ comments }) => {
	const sortedComments = [...(comments ?? [])].sort(
		(a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
	)
	return (
		<SpaceBetween direction="vertical" size="m">
			{sortedComments.length ? (
				sortedComments.map((item, index) => {
					const date = new Date(item.timestamp)
					return (
						<Box color="text-body-secondary" key={`${item.timestamp}-${index}`}>
							<div>
								{`${
									item.commenterID
								} on ${date.toLocaleTimeString()} ${date.toDateString()}`}
							</div>
							<div className="col">
								<Icon name="contact" size="inherit" variant="link" />{' '}
								<span style={{ whiteSpace: 'pre-wrap' }}>{item.comment}</span>
							</div>
						</Box>
					)
				})
			) : (
				<Box color="text-body-secondary">
					<Alert statusIconAriaLabel="Info" header="MongoDB Request Comments">
						You're All Caught Up!
					</Alert>
				</Box>
			)}
		</SpaceBetween>
	)
}

export default memo(CommentsOverview)
